import React from "react";
import { Link } from "react-router-dom";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Math() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 0 40px 0",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 12,
            }}
          >
            Math Projects
          </h1>
          <p
            style={{
              fontSize: "1.3rem",
              color: "#333",
              marginBottom: 32,
              maxWidth: 600,
              textAlign: "center",
            }}
          >
            Explore mathematical coding projects like calculating areas,
            factorials, LCM, and identifying prime numbers.
          </p>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 40,
              marginBottom: 40,
            }}
          >
            {/* Areas */}
            <Link to="/areas" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <ImageWithFallback
                src="/areas.png"
                alt="Areas"
                style={{
                  width: 220,
                  borderRadius: 18,
                  marginBottom: 18,
                }}
              />
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Areas
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                Learn how to calculate areas of different shapes with this coding
                project.
              </p>
              <a
                href="/Areas.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download Areas.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to calculate areas interactively.
              </div>
            </div>
            </Link>
            {/* Factorial */}
            <Link to="/factorial" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <ImageWithFallback
                src="/Factorial.png"
                alt="Factorial"
                style={{
                  width: 220,
                  borderRadius: 18,
                  marginBottom: 18,
                }}
              />
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Factorial
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                Calculate the factorial of a number with this Python project.
              </p>
              <a
                href="/Factorial.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download Factorial.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to calculate factorials interactively.
              </div>
            </div>
            </Link>
            {/* LCM */}
            <Link to="/lcm" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <ImageWithFallback
                src="/lcm.png"
                alt="LCM"
                style={{
                  width: 220,
                  borderRadius: 18,
                  marginBottom: 18,
                }}
              />
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                LCM
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                Find the Least Common Multiple of two numbers with this Python
                project.
              </p>
              <a
                href="/LCM.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download LCM.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to find LCM interactively.
              </div>
            </div>
            </Link>
            {/* Prime Numbers */}
            <Link to="/prime-numbers" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <ImageWithFallback
                src="/prime_numbers.png"
                alt="Prime Numbers"
                style={{
                  width: 220,
                  borderRadius: 18,
                  marginBottom: 18,
                }}
              />
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Prime Numbers
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 12,
                }}
              >
                Identify prime numbers with this Python project.
              </p>
              <a
                href="/Prime_number.py"
                download
                style={{
                  color: "#1976d2",
                  fontWeight: 600,
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Download Prime_number.py
              </a>
              <div
                style={{
                  marginTop: 10,
                  fontSize: "0.98rem",
                  color: "#555",
                }}
              >
                Run in Python to identify prime numbers interactively.
              </div>
            </div>
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}

export default Math;
